var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 43,
    viewBox: "0 0 35 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3423_947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4912 25.3637C22.6958 25.3637 26.9149 21.1094 26.9149 15.8615C26.9149 10.6136 22.6958 6.35938 17.4912 6.35938C12.2866 6.35938 8.06738 10.6136 8.06738 15.8615C8.06738 21.1094 12.2866 25.3637 17.4912 25.3637Z",
    stroke: "black",
    strokeWidth: 2.36457
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.97039 42.9999C4.73048 36.5851 10.5791 31.8709 17.4911 31.8709C24.4031 31.8709 30.2517 36.5851 32.0118 42.9999H34.2302C32.4151 35.3649 25.5948 29.708 17.4727 29.708C9.3507 29.708 2.56704 35.3649 0.751953 42.9999H2.97039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3051 15.8615C32.3051 7.61649 25.6681 0.924316 17.491 0.924316C9.31396 0.924316 2.69531 7.61649 2.69531 15.8615",
    stroke: "black",
    strokeWidth: 2.36457
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39026 13.144H0V21.2782H5.39026V13.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9996 13.144H29.6094V21.2782H34.9996V13.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8805 22.6462H17.4902V28.0813H22.8805V22.6462Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3054 18.5605V22.0915C32.3054 23.8847 30.857 25.3452 29.0786 25.3452H20.1865",
    stroke: "black",
    strokeWidth: 2.36457
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3423_947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 43,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.56de9e40401e6069f5ff8d4b913971b9.svg";
export { ForwardRef as ReactComponent };